/**
 * GENERATED FILE -- DO NOT EDIT.
 *
 * Source of truth: .claude/manifests/terminology/terms/*.yaml
 * Generator:       .claude/scripts/generate-terminology-labels.mjs
 * Regenerate:      .claude/scripts/generate-terminology-labels.mjs
 * Verify:          .claude/scripts/generate-terminology-labels.mjs --check
 *
 * Every string below is registered. Editing one here is invisible to the
 * register and is overwritten on the next run; change the register instead.
 *
 * No generation timestamp on purpose: re-running must produce a byte-identical
 * file, or --check reports drift on an unchanged register.
 */

/**
 * The i18n key form declared in .claude/manifests/terminology/registry.yaml
 * (`i18n.keyForm: term.<id>.value.<MEMBER>.label`), written in exactly one place. A locale catalog
 * keys on this form; the en-US maps below key on the bare enum member, which is
 * the same immutable id. English is never a lookup key in either.
 */
export function terminologyKey(termId: string, member: string): string {
  return `term.${termId}.value.${member}.label`;
}

/**
 * term `asset-class`, context `operatorConfig` -- 20 member(s).
 * Title Case, precise; the operator sets policy against these
 * Registers -- member: "asset type", fiStaff: "asset class", operator:
 * "asset class", public: "asset class"
 */
export const ASSET_CLASS_LABELS: Record<string, string> = {
  STABLECOINS: 'Stablecoins',
  PUBLIC_SECURITIES: 'Public Securities',
  COMMERCIAL_REAL_ESTATE: 'Commercial Real Estate',
  RESIDENTIAL_REAL_ESTATE: 'Residential Real Estate',
  INCOME_PROPERTY: 'Income Property',
  MAJOR_CRYPTOCURRENCY: 'Major Cryptocurrency',
  PUBLIC_REITS: 'Public REITs',
  TOKENIZED_SECURITIES: 'Tokenized Securities',
  PRIVATE_CREDIT: 'Private Credit',
  NON_TRADED_REITS: 'Non-Traded REITs',
  LP_INTERESTS_HEDGE_FUND: 'LP Interests (Hedge Fund)',
  LP_INTERESTS_PRIVATE_EQUITY: 'LP Interests (Private Equity)',
  RSU_RESTRICTED_STOCK: 'RSUs / Restricted Stock',
  PRIVATE_COMPANY_EQUITY: 'Private Company Equity',
  VENTURE_STARTUP_EQUITY: 'Venture / Startup Equity',
  US_TREASURIES: 'US Treasuries',
  CASH: 'Cash & Cash Equivalents',
  OTHER_DIGITAL_ASSETS: 'Other Digital Assets',
  OPTIONS: 'Options / Derivatives',
  OTHER: 'Other',
};

/**
 * term `security-type`, context `operatorConfig` -- 8 member(s).
 * Sentence case; an instrument grouping, never shown as a policy key
 * Registers -- fiStaff: "security type", operator: "security type"
 */
export const SECURITY_TYPE_LABELS: Record<string, string> = {
  EQUITY: 'Equity',
  FIXED_INCOME: 'Fixed income',
  MUTUAL_FUND: 'Mutual fund',
  ETF: 'ETF',
  OPTION: 'Option',
  FUTURE: 'Future',
  CASH: 'Cash',
  OTHER: 'Other',
};
